export default __webpack_public_path__ + "media/assets/fonts/roboto-v20-latin-italic-d022bc70dc1bf7b3425da9cdaa9841b6.woff2";